var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"cart-symbol"},[_vm._v("🛒")]),(_vm.count > 0)?_c('span',{staticClass:"cart-count"},[_vm._v(_vm._s(_vm.displayCount))]):_vm._e(),(_vm.showLabel)?_c('span',{staticClass:"cart-label"},[_vm._v(_vm._s(_vm.$t('common.cart')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }